

import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      ventas: [],

      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
      }

    };
  },

  computed: {
    reporte: function () {
      return '/reportes/cupones/liquidados/promo?dsis=' + window.sssdi + '&desde=' + this.f_c.desde + '&hasta=' + this.f_c.hasta

    }
  },

  mounted: function () {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,

      'rowCallback': function (row, data, index) { },



    });
    $('.box').boxWidget();

  },

  methods: {
    consultar() {
      this.loading = true;

      this.tbv.clear();


      this.$http
        .post('/reportes/cupones/liquidados/promo', this.f_c)
        .then(response => {
          response.data.data.forEach(e => {
            e[11] = this.num_to_many(e[11]);
            e[16] = this.num_to_many(e[16]);
            e[17] = this.num_to_many(e[17]);
            e[18] = this.num_to_many(e[18]);
            e[19] = this.num_to_many(e[19]);
            e[20] = this.num_to_many(e[20]);
            e[24] = this.num_to_many(e[24]);
            e[25] = this.num_to_many(e[25]);
            e[26] = this.num_to_many(e[26]);
            e[27] = this.num_to_many(e[27]);
            e[28] = this.num_to_many(e[28]);
            this.tbv.row.add(e);
          });
          this.tbv.draw();
          this.loading = false;
        }).catch(e => {
          this.loading = false;
        });

    },

  }


};



// WEBPACK FOOTER //
// ./src/components/reportes/cuponesLiquidadosPromo/tventas/index.js